import { useEffect, useState } from 'react'
import useBusinessTravellerSocieteDetailsFetcher from 'businessTraveller/hooks/useBusinessTravellerSocieteDetailsFetcher'
import useSocieteCampaignTargetTier from 'loyalty/hooks/useSocieteCampaignTargetTier'
import { isAtOrAboveLoyaltyTier } from 'loyalty/utils/isAtOrAboveLoyaltyTier'

// Delay reveal so the modal doesn't pop the instant the user lands on the page.
const UNLOCK_TIER_REVEAL_DELAY_MS = 3000

function useSocieteNotificationFetcher() {
  const [isVisible, setIsVisible] = useState(false)
  const { targetTier } = useSocieteCampaignTargetTier()
  const { isFetching, societeTierSetting, linkedCreditAccount, employeeNotification } = useBusinessTravellerSocieteDetailsFetcher(targetTier)

  const isAtOrAboveTargetTier = isAtOrAboveLoyaltyTier(linkedCreditAccount?.tier, targetTier)

  const isEligible =
    !isFetching &&
    !!societeTierSetting?.enabled &&
    !isAtOrAboveTargetTier &&
    !employeeNotification?.societe?.unlockTierDismissed

  useEffect(() => {
    if (!isEligible) return
    const timeout = setTimeout(() => setIsVisible(true), UNLOCK_TIER_REVEAL_DELAY_MS)
    return () => clearTimeout(timeout)
  }, [isEligible])

  return isVisible && isEligible
}

export default useSocieteNotificationFetcher
